<template>
  <v-card flat class="pa-6" v-if="instructions">
    <MessageBox class="mb-8">
      <p class="fontsize-14">
        Detta är den version av handledarinstruktionerna som visas på Mina sidor nu. Den speglar inte eventuella ännu
        icke publicerade ändringar.
      </p>
    </MessageBox>
    <h5>VERSION PUBLICERAD {{ instructions.committedAt | date }}</h5>
    <v-card flat outlined class="ma-0 pa-4">
      <h6 class="bold">Sammanfattning av ändringar</h6>
      <div v-html="renderMarkdown(instructions.commitMessage)" />
    </v-card>

    <!-- <div class="pt-4" v-html="renderMarkdown(instructions.content)" /> -->

    <template v-if="instructions.sections && instructions.sections.items">
      <div v-for="section in instructions.sections.items" :key="section.id">
        <PreviewInstructionsSection :section="section" />
      </div>
    </template>
  </v-card>
</template>

<script>
import marked from 'marked'
import API from '@/services/api.js'
import {RulesMixin} from '@/components/mixins'
import MessageBox from '@/components/common/MessageBox.vue'
import PreviewInstructionsSection from '@/components/admin/instructions/PreviewInstructionsSection.vue'

export default {
  name: 'PreviewInstructions',

  components: {
    MessageBox,
    PreviewInstructionsSection
  },

  props: {
    tab: {
      type: Number,
      default: null
    }
  },

  data: () => ({
    instructions: {}
  }),

  mixins: [RulesMixin],

  created() {
    this.init()
  },

  watch: {
    tab(newTab) {
      if (newTab === 2) {
        this.init()
      }
    }
  },

  methods: {
    init() {
      API.getCurrentInstructions().then(({data}) => {
        this.instructions = data
      })
    },
    renderMarkdown(value) {
      if (!value) return null
      return marked(value)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>